import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

export default {
  getScreens() {
    return fetch(getUrl('/screens'));
  },

  getScreen(id) {
    return fetch(getUrl(`/screens/${id}`));
  },

  createScreen(screen) {
    return fetch(getUrl('/screens'), {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(screen),
    });
  },

  editScreen(id, fields = {}) {
    return fetch(getUrl(`/screens/${id}`), {
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(fields),
    });
  },

  deleteScreen(id) {
    return fetch(getUrl(`/screens/${id}`), {
      method: 'DELETE',
      headers: {
        'content-type': 'application/json',
      },
    });
  },
};
